/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import { getLocalizedByName } from '@/helpers'
import find from 'lodash/find'

function localizedByName (name, $store, $router) {
  return getLocalizedByName(name, $store.state.ui.urlCode, $router)
}

export function localizedByNameCategories (name, path, category, $store, $router) {
  if (category && category.blogHelpers) {
    return localizedByName('home', $store, $router) + path
  }
  let suffix = ''
  if (name === 'listing') {
    name = 'factoryPage'
    suffix = '.html'
  }
  return localizedByName(name, $store, $router) + (path ? `/${path}` : '') + suffix
}

export function prodCatPaths (product, store) {
  if (product.categories && product.categories.length) {
    let masterCategory = product.categories[0]
    if (masterCategory.breadcrumbs === null) {
      masterCategory.breadcrumbs = []
    }
    // find breadcrcumb more length
    product.categories.forEach(cat => {
      if (cat.breadcrumbs && cat.breadcrumbs.length) {
        if (cat.breadcrumbs.length >= masterCategory.breadcrumbs.length) {
          masterCategory = cat
        }
      }
    })
    if (masterCategory) {
      const findCat = find(store.state.category.flatted, { id: masterCategory.id })
      if (findCat) {
        return findCat.url_path + '/'
      }
    }
  }
  return ''
}

export { localizedByName }

export default {
  localizedByName,
  localizedByNameCategories,
  prodCatPaths
}
